import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import http from 'src/helper/http'

import lang from '../lang'

// const rankingData = JSON.parse(localStorage.getItem('rankingData'));
// console.log(rankingData, '999999999999999');

export default class extends React.Component {
  state = {
    shareStatus: false,
    giftList: 1,
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  hideShare = async (status) => {
    this.setState({
      shareStatus: status
    })
  }

  setActiveList = async (status) => {
    this.setState({
      giftList: status
    })
  }

  render() {
    let { language, list, lang, nav, now, giftData } = this.props

    return (
      <div className="page">
        {this.state.shareStatus && <div className="loading"></div>}

        {this.state.shareStatus && <div className={`hideShare ${language == 'ar' && 'arlang'}`}>
          <div className="ptop">Rank Reward</div>

          <div className="content">
            <div className='content-word'>

              <div className={`nav navbg${nav} ${language == 'ar' && 'arlang'}`}>
                <div className={`navitem1 ${this.state.giftList === 1 && "active"}`} onClick={() => this.setActiveList(1)}>Reputation</div>
                <div className={`navitem2 ${this.state.giftList === 2 && "active"}`} onClick={() => this.setActiveList(2)}>Fame</div>
              </div>

              {this.state.giftList === 1 && (
                <div>
                  <div className="content-layout">
                    <div className="content-layout-top">NO.1</div>

                    <div className="content-layout-box">
                      {giftData.sender_reward1.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="content-layout">
                    <div className="content-layout-top">NO.2</div>
                    <div className="content-layout-box">
                      {giftData.sender_reward2.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="content-layout">
                    <div className="content-layout-top">NO.3</div>
                    <div className="content-layout-box">
                      {giftData.sender_reward3.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {this.state.giftList === 2 && (
                <div>
                  <div className="content-layout">
                    <div className="content-layout-top">NO.1</div>

                    <div className="content-layout-box">
                      {giftData.receiver_reward1.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="content-layout">
                    <div className="content-layout-top">NO.2</div>
                    <div className="content-layout-box">
                      {giftData.receiver_reward2.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="content-layout">
                    <div className="content-layout-top">NO.3</div>
                    <div className="content-layout-box">
                      {giftData.receiver_reward3.map((item) => (
                        <div className="content-layout-boxConten" key={item.giftid}>
                          <div>
                            <img src={item.giftIcon} />
                          </div>
                          <p>{item.giftName}</p>
                          <span>({item.expire})</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>

          <div className="pbottom" onClick={this.hideShare.bind(this, false)}>
            <img src='/img/app/ruby/monopoly/close_button.png' />
          </div>

        </div>}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/app/ruby-monopoly/Share/index.js